      <template>
  <div></div>
</template>

<style>
.responsiveImage {
  max-width: 40%;
  width: auto;
  height: auto;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
// ******************** Select ********************//
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosPost("Account/Logout", {}, this, function(data) {
      if (data.ResponseVM != null) {
        context.$store.dispatch("logout").then(() => {
          context.$router.push("login");
        });
      }
    });
  }
};
</script>